module.exports = __webpack_public_path__ + "img/bmfw.1e774407.png";